module.exports = __webpack_public_path__ + "media/newstyle/images/a5-f0a6c1a8054d62f46ac309319026c179.svg";